import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Container from '@mui/material/Container';
import { Button } from '@mui/material';
import Typography from '@mui/material/Typography';
import { confirmUser } from "../../api/Api";
import GlowCard from '../../shared/GlowCard';
import { useColors } from '../../theme/ColorModeContext';
import AuthBrandHeader from '../../shared/AuthBrandHeader';

const Confirm = () => {
    const colors = useColors();
    const [message, setMessage] = useState("");
    const { token } = useParams();

    useEffect(() => {
        const confirm = async () => {
            const data = await confirmUser(token);
            setMessage(data.msg);
        }
        confirm();
    }, [])

    return (
        <Container sx={{ marginTop: '120px', marginBottom: '60px' }} disableGutters maxWidth="sm" className="page-enter">
            <AuthBrandHeader />
            <GlowCard gradientBorder sx={{ padding: '48px 32px', textAlign: 'center' }}>
                <Typography variant="h4" sx={{
                    fontFamily: '"Orbitron", sans-serif',
                    fontWeight: 700,
                    background: colors.gradient.primary,
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                    marginBottom: '24px',
                }}>
                    Email Confirmation
                </Typography>
                {message && (
                    <Typography variant="body1" sx={{
                        color: colors.text.secondary,
                        marginBottom: '24px',
                    }}>
                        {message}
                    </Typography>
                )}
                <Link to={"/login"} style={{ textDecoration: 'none' }}>
                    <Button variant="contained" sx={{ padding: '12px 48px' }}>
                        Sign In
                    </Button>
                </Link>
            </GlowCard>
        </Container>
    );
}

export default Confirm;
